export default function PropertySpecs({ property }) {
  return (
    <div className="border rounded-lg p-6 mt-8 bg-white">
      <h2 className="text-2xl font-semibold text-blue-900 mb-4">Thông tin chi tiết</h2>

      <div className="grid grid-cols-2 gap-4 text-sm text-blue-900">
        <div><span className="text-gray-600">Dự án:</span> <b>{property?.projectName ?? "Chưa có tên dự án"}</b></div>
        <div><span className="text-gray-600">Loại hình:</span> <b>{property?.propertyType ?? "—"}</b></div>
        <div><span className="text-gray-600">Phân khu / Block:</span> <b>{property?.block ?? "—"}</b></div>
        <div><span className="text-gray-600">Mã căn:</span> <b>{property?.unitCode ?? "—"}</b></div>
        <div><span className="text-gray-600">Phòng ngủ:</span> <b>{property?.bedrooms ?? "—"}</b></div>
        <div><span className="text-gray-600">Phòng tắm:</span> <b>{property?.bathrooms ?? "—"}</b></div>
        <div><span className="text-gray-600">Diện tích:</span> <b>{property?.area ? `${property.area} m²` : "—"}</b></div>
        <div><span className="text-gray-600">Nội thất:</span> <b>{property?.furniture ?? "—"}</b></div>
        <div><span className="text-gray-600">Pháp lý:</span> <b>{property?.legalStatus ?? "—"}</b></div>
        <div><span className="text-gray-600">Trạng thái bàn giao:</span> <b>{property?.handoverStatus ?? "—"}</b></div>
      </div>
    </div>
  );
}
